const isEnterKeyWithoutShift = (e) => {
    return (e.code === 'Enter' || e.key === 'Enter' || e.keyCode === 13) && !e.shiftKey;
};
/**
 * Applies the shared keydown behavior for composer-backed text inputs.
 *
 * @param event - The native keyboard event emitted by the input or editor root.
 */
export const handleKeyDownInput = (event, params) => {
    /* Prevent the submit gesture when IME is composing and ENTER key is pressed
     * This is common in Japanese keyboards where the user presses ENTER to
     * select a suggestion from the IME.
     *
     * Although keyCode is marked as deprecated, it is necessary to ensure that we are
     * able to properly handle IME keyboards and not prematurely submit in Safari
     * Context: https://dninomiya.github.io/form-guide/stop-enter-submit
     *
     * Callers express their Enter policy through enterKeyBehavior. Callers that
     * want plain Enter to insert a newline should pass "newline" so the
     * browser/editor can handle Enter normally. Callers that treat plain Enter as
     * submit should pass "submit" so the newline is suppressed.
     */
    if (isEnterKeyWithoutShift(event)) {
        if (params.isComposing || event.keyCode === 229) {
            event.preventDefault(); // prevent action while IME is composing
            return;
        }
        if (params.enterKeyBehavior === 'newline') {
            return; // let the newline through
        }
        event.preventDefault(); // 'submit' -> suppress newline, Enter is the submit gesture
    }
    // in all other cases, call the onKeyDown handler
    params.onKeyDown?.(event);
};
//# sourceMappingURL=keyboard.js.map